import {
  MdDashboard,
  MdOutlineImage,
  MdLocationCity,
  MdSettings,
  MdOutlineAirplay,
  MdSupervisorAccount,
  MdDvr,
  MdDescription,
  // MdAdb,
  MdTour,
  MdLink,
} from "react-icons/md";
import { faBars, faPlus, faRightFromBracket, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styleSidebar from "./Sidebar.module.css";
import { useGetBasicSettingsList } from "../../api/settings";
import { useNavbarLogo } from "../../hooks/useNavbarLogo";
import { isEditor, isUberadmin } from "../../utils/permissions";

const Sidebar = ({ visibility, setVisibility, user }) => {
  const [showSettingsList, setShowSettingsList] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const {
    data: basicSettingData,
    isLoading: isLoadingBasicSettings,
  } = useGetBasicSettingsList();

  const [sideBarValue, setSideBarValue] = useState({
    dashboard: false,
    scene: false,
    // interaction: false,
    categories: false,
    // productCategories: false,
    unityScene: false,
    // products: false,
    users: false,
    audit: false,
    fileLibrary: false,
    settings: false,
    tours: false,
    webUrls: false,
  });

  const handleLogout = () => {
    localStorage.removeItem("Token");
    navigate("/login");
  };

  const isActive = path => {
    const current = location.pathname;
    if (path === "dashboard") {
      return current === "/web-twinprocms" || current === "/web-twinprocms/dashboard";
    }
    return current.includes(`/web-twinprocms/${path}`);
  };

  const itemClass = path =>
    `${styleSidebar.sidebarItem} ${isActive(path) ? styleSidebar.sidebarItemActive : ""}`;

  const subItemClass = path =>
    `${styleSidebar.sidebarSubItem} ${
      location.pathname.includes(path) ? styleSidebar.sidebarSubItemActive : ""
    }`;

  useEffect(() => {
    if (isUberadmin(user)) {
      setSideBarValue(prevState => ({
        ...prevState,
        audit: true,
        categories: true,
        dashboard: true,
        fileLibrary: true,
        scene: true,
        settings: true,
        unityScene: true,
        webUrls: true,
        users: true,
        tours: true,
      }));
      return;
    }

    if (isEditor(user)) {
      setSideBarValue(prevState => ({
        ...prevState,
        dashboard: true,
        users: true,
        categories: true,
        scene: true,
        unityScene: true,
        webUrls: true,
        tours: true,
        fileLibrary: true,
        settings: true,
        audit: true,
      }));
    }
  }, [user]);

  useEffect(() => {
    const current = location.pathname;
    if (
      current.includes("/basic-settings") ||
      current.includes("/homepage-options") ||
      current.includes("/theme-options") ||
      current.includes("/share-icon")
    ) {
      setShowSettingsList(true);
    }
  }, [location.pathname]);

  const brandName = process.env.REACT_APP_BRAND || "Web-Twin";
  const envFallbackLogo = `${window.location.origin}/assets/${process.env.REACT_APP_LOGO}`;
  const logoSrc =
    useNavbarLogo(
      basicSettingData?.navbar_logo,
      isLoadingBasicSettings,
      envFallbackLogo
    ) ?? envFallbackLogo;

  const closeMobile = () => setVisibility(false);

  return (
    <aside className={styleSidebar.sidebar}>
      <div className={styleSidebar.sidebarHeader}>
        <Link
          to="/web-twinprocms/dashboard"
          className={styleSidebar.navBrand}
          onClick={closeMobile}
        >
          <img src={logoSrc} alt={`${brandName} logo`} />
          {/* <span className={styleSidebar.brandText}>
            {brandName}
            <span className={styleSidebar.brandAccent}> CMS</span>
          </span> */}
        </Link>
        <button
          type="button"
          className={styleSidebar.mobileMenuBtn}
          onClick={() => setVisibility(!visibility)}
          aria-label={visibility ? "Close menu" : "Open menu"}
        >
          <FontAwesomeIcon icon={visibility ? faXmark : faBars} />
        </button>
      </div>

      <nav className={styleSidebar.sidebarNav}>
        <ul className={styleSidebar.sidebarList}>
          {sideBarValue?.dashboard && (
            <li className={itemClass("dashboard")}>
              <MdDashboard />
              <Link to="dashboard" state={{ title: "Dashboard" }} onClick={closeMobile}>
                Dashboard
              </Link>
            </li>
          )}

          {sideBarValue?.scene && (
            <li className={itemClass("scene")}>
              <MdOutlineImage />
              <Link to="scene" state={{ title: "Scenes" }} onClick={closeMobile}>
                Scenes
              </Link>
            </li>
          )}

          {/* {sideBarValue?.interaction && (
            <li className={itemClass("interaction")}>
              <MdOutlineImage />
              <Link to="interaction" state={{ title: "Interations" }} onClick={closeMobile}>
                Interactions
              </Link>
            </li>
          )} */}

          {sideBarValue?.categories && (
            <li className={itemClass("categories")}>
              <MdLocationCity />
              <Link to="categories" state={{ title: "Categories" }} onClick={closeMobile}>
                Categories
              </Link>
            </li>
          )}

          {/* {sideBarValue?.productCategories && (
            <li className={itemClass("product-category")}>
              <MdAdb />
              <Link
                to="product-category"
                state={{ title: "Product Categories" }}
                onClick={closeMobile}
              >
                Product Categories
              </Link>
            </li>
          )} */}

          {sideBarValue?.unityScene && (
            <li className={itemClass("unity-scene")}>
              <MdOutlineAirplay />
              <Link to="unity-scene" state={{ title: "Unity Scene" }} onClick={closeMobile}>
                Unity Scene
              </Link>
            </li>
          )}

          {sideBarValue?.webUrls && (
            <li className={itemClass("web-urls")}>
              <MdLink />
              <Link to="web-urls" state={{ title: "Web URLs" }} onClick={closeMobile}>
                Web URLs
              </Link>
            </li>
          )}

          {sideBarValue?.tours && (
            <li className={itemClass("360-tours")}>
              <MdTour />
              <Link to="360-tours" state={{ title: "360 Tours" }} onClick={closeMobile}>
                360 Tours
              </Link>
            </li>
          )}

          {/* {sideBarValue?.products && (
            <li className={itemClass("products")}>
              <MdAdb />
              <Link to="products" state={{ title: "Products" }} onClick={closeMobile}>
                Products
              </Link>
            </li>
          )} */}

          {(sideBarValue?.users || sideBarValue?.audit || sideBarValue?.fileLibrary) && (
            <li aria-hidden="true">
              <div className={styleSidebar.sidebarDivider} />
            </li>
          )}

          {sideBarValue?.users && (
            <li className={itemClass("users")}>
              <MdSupervisorAccount />
              <Link to="users" state={{ title: "User" }} onClick={closeMobile}>
                Users
              </Link>
            </li>
          )}

          {sideBarValue?.audit && (
            <li className={itemClass("audit")}>
              <MdDvr />
              <Link to="audit" state={{ title: "Audit" }} onClick={closeMobile}>
                Audit
              </Link>
            </li>
          )}

          {sideBarValue?.fileLibrary && (
            <li className={itemClass("file-library")}>
              <MdDescription />
              <Link to="file-library" onClick={closeMobile}>
                File Library
              </Link>
            </li>
          )}

          {sideBarValue?.settings && (
            <li>
              <div
                className={`${styleSidebar.sidebarItem} ${
                  isActive("basic-settings") ||
                  isActive("homepage-options") ||
                  isActive("theme-options") ||
                  isActive("share-icon")
                    ? styleSidebar.sidebarItemActive
                    : ""
                }`}
                onClick={() => setShowSettingsList(prev => !prev)}
              >
                <MdSettings />
                <span>Settings</span>
                <FontAwesomeIcon icon={faPlus} className={styleSidebar.expandBtn} />
              </div>
              {showSettingsList && (
                <ul className={styleSidebar.sidebarSubList}>
                  {isUberadmin(user) && (
                    <li>
                      <Link
                        to="basic-settings"
                        className={subItemClass("basic-settings")}
                        state={{ title: "Basic Settings" }}
                        onClick={closeMobile}
                      >
                        Basic Settings
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}
        </ul>
      </nav>

      <footer className={styleSidebar.sidebarFooter}>
        <div className={styleSidebar.logoutItem} onClick={handleLogout}>
          <FontAwesomeIcon icon={faRightFromBracket} />
          <span>Logout</span>
        </div>
      </footer>
    </aside>
  );
};

export default Sidebar;
